// const Error = () => {
//   return <div>Something went wrong!</div>
// }

import { useSelector } from "react-redux";
import { useRouteError, useNavigate } from "react-router-dom";

export default function Error() {
  const token = useSelector(state => state.user)
  const navigate = useNavigate();
  if (!token.token) {
    navigate('login');
  }
  const error = useRouteError();
  console.error(error); // or redirect to /

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}
